import React, { Component, Fragment } from "react";
import { Tag, Input, Button } from "antd";
import MD5 from "blueimp-md5";

export default class TagsInput extends Component {
	constructor(props) {
		super(props);
		const tags = props.tags || "";
		this.state = {
			tags: tags.split(",").filter(tag => tag.length != 0),
			inputValue: ""
		};
	}

	componentWillReceiveProps(nextProps) {
		if ("tags" in nextProps) {
			const tags = nextProps.tags || "";						
			this.setState({
				tags: tags.split(",").filter(tag => tag.length != 0),
				inputValue: ""
			});
		}
	}

	handleInputChange = e => {
		this.setState({ inputValue: e.target.value });
	};

	handleClose = index => {
		const tags = [
			...this.state.tags.slice(0, index),
			...this.state.tags.slice(index + 1, this.state.tags.length)
		];
		// this.state.tags.splice(index, 1);
		this.setState({ tags });
		this.props.onChange(tags.join());
	};

	handleInputConfirm = () => {
		const state = this.state;
		const inputValue = state.inputValue;
		let tags = state.tags;
		if (inputValue) {
			const newTags = inputValue.split(",");
			for (let tag of newTags) {
				let normalizedTag = tag.trim();
				if (tags.indexOf(normalizedTag) === -1) {
					tags.push(normalizedTag);
				}
			}
			// tags = [...tags, ...newTags];
		}
		this.setState({
			tags,
			inputValue: ""
		});
		this.props.onChange(tags.join());
	};

	clearAllTags = () => {
		let tags = [];
		this.setState({
			tags,
			inputValue: ""
		});
		this.props.onChange(tags.join());
	}

	saveInputRef = input => (this.input = input);

	render() {
		const { tags, inputValue } = this.state;
		const inputVisible = !this.props.disabled;
		return (
			<div>
				{this.state.tags.map((tag, index) => {
					return (
						<Tag
							key={MD5(tag)}
							closable={inputVisible}
							afterClose={() => this.handleClose(index)}
						>
							{tag}
						</Tag>
					);
				})}
				{inputVisible && (
					<Fragment>
					<Input
						ref={this.saveInputRef}
						type="text"
						size="small"
						style={{ width: 78 }}
						value={inputValue}
						onChange={this.handleInputChange}
						onBlur={this.handleInputConfirm}
						onPressEnter={this.handleInputConfirm}
					/>
					{' '}
					<Button size="small" type="primary" onClick={this.clearAllTags}>Clear All Tags</Button>
					</Fragment>
				)}
			</div>
		);
	}
}
